export default {"src":"/_next/static/media/estimates.9093faae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};